export class ClassificaGescorVO {
  denominazione: string;
  livello: string;
  output: string;
  codice: string;
  abilitaInvioComunicazioniDipendenti: boolean;
}
